import Vue, { VueConstructor } from 'vue';
import ClAmbientProgress from './ClAmbientProgress';
import ClAppBar from './ClAppBar';
import ClAvatar from './ClAvatar';
import ClBackdrop from './ClBackdrop';
import ClBadge from './ClBadge';
import ClButton from './ClButton';
import ClButtonBase from './ClButtonBase';
import ClCard from './ClCard';
import ClCardActionArea from './ClCardActionArea';
import ClCardActions from './ClCardActions';
import ClCardContent from './ClCardContent';
import ClCardHeader from './ClCardHeader';
import ClCardMedia from './ClCardMedia';
import ClCheckbox from './ClCheckbox';
import ClChip from './ClChip';
import ClCircularProgress from './ClCircularProgress';
import ClClickAwayListener from './ClClickAwayListener';
import ClCollapse from './ClCollapse';
import ClContainer from './ClContainer';
import ClDialog from './ClDialog';
import ClDialogActions from './ClDialogActions';
import ClDialogContent from './ClDialogContent';
import ClDivider from './ClDivider';
import ClDrawer from './ClDrawer';
import ClFormControl from './ClFormControl';
import ClFormControlLabel from './ClFormControlLabel';
import ClFormHelperText from './ClFormHelperText';
import ClFormGroup from './ClFormGroup';
import ClFormLabel from './ClFormLabel';
import ClIcon from './ClIcon';
import ClIconButton from './ClIconButton';
import ClInput from './ClInput';
import ClInputAdornment from './ClInputAdornment';
import ClInputBase from './ClInputBase';
import ClLinearProgress from './ClLinearProgress';
import ClList from './ClList';
import ClListItem from './ClListItem';
import ClListItemAvatar from './ClListItemAvatar';
import ClListItemIcon from './ClListItemIcon';
import ClListItemSecondaryAction from './ClListItemSecondaryAction';
import ClListItemText from './ClListItemText';
import ClListSubheader from './ClListSubheader';
import ClMenu from './ClMenu';
import ClMenuItem from './ClMenuItem';
import ClMenuList from './ClMenuList';
import ClModal from './ClModal';
import ClPaper from './ClPaper';
import ClPopover from './ClPopover';
import ClPopper from './ClPopper';
import ClProvider from './ClProvider';
import ClRadio from './ClRadio';
import ClRadioGroup from './ClRadioGroup';
import ClSnackbar from './ClSnackbar';
import ClSnackbarContent from './ClSnackbarContent';
import ClSelect from './ClSelect';
import ClSlide from './ClSlide';
import ClSvgIcon from './ClSvgIcon';
import ClSwitch from './ClSwitch';
import ClTab from './ClTab';
import ClTabs from './ClTabs';
import ClTabsLegacy from './ClTabsLegacy';
import ClTextField from './ClTextField';
import ClToolbar from './ClToolbar';
import ClTooltip from './ClTooltip';
import ClTypography from './ClTypography';

interface ComponentsType {
  [key: string]: VueConstructor;
}

const Components: ComponentsType = {
  ClAmbientProgress,
  ClAppBar,
  ClAvatar,
  ClBackdrop,
  ClBadge,
  ClButton,
  ClButtonBase,
  ClCard,
  ClCardActionArea,
  ClCardActions,
  ClCardContent,
  ClCardHeader,
  ClCardMedia,
  ClCheckbox,
  ClChip,
  ClCircularProgress,
  ClClickAwayListener,
  ClCollapse,
  ClContainer,
  ClDialog,
  ClDialogActions,
  ClDialogContent,
  ClDivider,
  ClDrawer,
  ClFormControl,
  ClFormControlLabel,
  ClFormGroup,
  ClFormHelperText,
  ClFormLabel,
  ClIcon,
  ClIconButton,
  ClInput,
  ClInputAdornment,
  ClInputBase,
  'cl-label': ClFormLabel, // deprecate
  ClLinearProgress,
  ClList,
  ClListItem,
  ClListItemAvatar,
  ClListItemIcon,
  ClListItemSecondaryAction,
  ClListItemText,
  ClListSubheader,
  ClMenu,
  ClMenuItem,
  ClMenuList,
  ClModal,
  ClRadio,
  ClRadioGroup,
  ClPaper,
  ClPopover,
  ClPopper,
  ClProvider,
  ClSnackbar,
  ClSnackbarContent,
  ClSelect,
  ClSlide,
  ClSvgIcon,
  ClSwitch,
  ClTab,
  ClTabs,
  ClTabsLegacy,
  ClTextField,
  ClToolbar,
  ClTooltip,
  ClTypography
};

Object.keys(Components).forEach(name => {
  Vue.component(name, Components[name]);
});

export default Components;
